import generateText from '../pattern_utilities/generateText';
import generateName from '../pattern_utilities/generateName';
import checkForErrors from '../pattern_utilities/checkForErrors';
import downloadPatFile from '../pattern_utilities/downloadPatFile.js'
import roundValue from '../pattern_utilities/roundValue.js'
import deepDefaults from '../pattern_utilities/deepDefaults.js'
import defaultJDISettings from '../pattern_utilities/defaultJDISettings'

const blankPatternTemplate = {
  name: 'untitled',
  description: '',
  type: 'MODEL',
  units: 'INCH',
  format: 'REVIT',
  undoIndex: 0,
  private: false,
  mode: 'raster',
  lineSegments: [],
  rows: [
  ]
}

blankPatternTemplate.text = generateText(blankPatternTemplate);




const blankDrawingPatternTemplate = {
  name: 'untitled',
  description: '',
  type: 'MODEL',
  units: 'INCH',
  format: 'REVIT',
  mode: 'drawing',
  width: 12,
  height: 12,
  lineSegments: [],
  undoIndex: 0,
  private: false,
  rows: [],
  jdiSettings: JSON.parse(JSON.stringify(defaultJDISettings))
}


blankDrawingPatternTemplate.text = generateText(blankDrawingPatternTemplate);

var landingTextDemos = [
  {
    "name": "",
    "description": "",
    "type": "MODEL",
    "format": "REVIT",
    "units": "INCH",
    "rows": [{
      "original_index": 0,
      "cells": [0,      0,      0,      19,     -1,     13,     -47]
    }, {
      "original_index": 1,
      "cells": [90,     3,      0,      19,     1,      13,     -47]
    }],
    "width": 12,
    "height": 12,
    mode: 'raster',
    variables: [
      {type: "units", name: "width", display: "Board Width", value: 3},
      {type: "units", name: "length", value: 10, display: "Board Length"}
    ],
    calculator: 'hech1b',
    notes: 'Board Length should be greater than Board Width.',
    "tags": [],
    "projects": [],
    "text": `;%UNITS=INCH
;%VERSION=3.0
;
*untitled
;%TYPE=MODEL
;
;angle, x,      y,      shift,  offset, dash,   space
0,      0,      0,      19,     -1,     13,     -47
90,     3,      0,      19,     1,      13,     -47
`,
    "scale_factor": 1,
    "decimal_places": 8,
    "private": false,
    jdiSettings: JSON.parse(JSON.stringify(defaultJDISettings))
  }
]


var i, j;

var maxHistoryMemory = 50;

function addToNewHistory(history, new_data){
  
  history = Object.assign(resetHistory(), history);

  if(history.undoIndex > 0){
    history.memory.splice(history.memory.length - history.undoIndex, history.undoIndex);
  }

  history.memory.push(new_data);
  if(history.memory.length > maxHistoryMemory) history.memory.splice(0,1);
  history.undoIndex = 0;

  return history;
}

function resetHistory(){
  return {
    memory: [],
    undoIndex: 0
  }
}


function addToList(list, newItems){
  for(var i in newItems){
    var found = false;
    for(var j in list){
      if(newItems[i] == list[j]){
        found = true;
        break;
      }
    }
    if(!found) list.push(newItems[i]);
  }
  return list;
}

function quickHash(rows, includeStyle) {
  var localRows = JSON.parse(JSON.stringify(rows));
  var t = [];
  for(var i in localRows){

    var n = {
      cells: localRows[i].cells
    }
    if(includeStyle){
      n.invisible = localRows[i].invisible;
      n.bold = localRows[i].bold;
      n.greyscale = localRows[i].greyscale;
    }

    t.push(n);

    for(var j = 0; j < t[i].cells.length; j++){
      if(t[i].cells[j] == ""){
        t[i].cells.splice(j, 1);
        j--;
      } else {
        t[i].cells[j] = parseFloat(t[i].cells[j]);
      }
    }
  }

  var string = JSON.stringify(t);
 
  var hash = 0;
  if (string.length == 0) {
    return hash;
  }
  for (var i = 0; i < string.length; i++) {
    var char = string.charCodeAt(i);
    hash = ((hash<<5)-hash)+char;
    hash = hash & hash; 
  }
  return hash;
}


let tutorial_intro_01 = require('../patterns/tutorial_intro_01.js');
let tutorial_intro_02 = require('../patterns/tutorial_intro_02.js');
let tutorial_intro_03 = require('../patterns/tutorial_intro_03.js');
let tutorial_intro_04 = require('../patterns/tutorial_intro_04.js');
let tutorial_intro_05 = require('../patterns/tutorial_intro_05.js');
let tutorial_intro_06 = require('../patterns/tutorial_intro_06.js');
let tutorial_intro_07 = require('../patterns/tutorial_intro_07.js');
let tutorial_intro_08 = require('../patterns/tutorial_intro_08.js');
let tutorial_intro_09 = require('../patterns/tutorial_intro_09.js');

export const patternManager = (state = {
  cache: {
    local: JSON.parse(JSON.stringify(blankDrawingPatternTemplate)),
    features_text: landingTextDemos[0],
    features_text2: landingTextDemos[0],
    tutorial_intro_01: tutorial_intro_01,
    tutorial_intro_02: tutorial_intro_02,
    tutorial_intro_03: tutorial_intro_03,
    tutorial_intro_04: tutorial_intro_04,
    tutorial_intro_05: tutorial_intro_05,
    tutorial_intro_06: tutorial_intro_06,
    tutorial_intro_07: tutorial_intro_07,
    tutorial_intro_08: tutorial_intro_08,
    tutorial_intro_09: tutorial_intro_09,
  },
  pristineCache: {
    tutorial_intro_01: JSON.parse(JSON.stringify(tutorial_intro_01)),
    tutorial_intro_02: JSON.parse(JSON.stringify(tutorial_intro_02)),
    tutorial_intro_03: JSON.parse(JSON.stringify(tutorial_intro_03)),
    tutorial_intro_04: JSON.parse(JSON.stringify(tutorial_intro_04)),
    tutorial_intro_05: JSON.parse(JSON.stringify(tutorial_intro_05)),
    tutorial_intro_06: JSON.parse(JSON.stringify(tutorial_intro_06)),
    tutorial_intro_07: JSON.parse(JSON.stringify(tutorial_intro_07)),
    tutorial_intro_08: JSON.parse(JSON.stringify(tutorial_intro_08)),
    tutorial_intro_09: JSON.parse(JSON.stringify(tutorial_intro_09)),
  },
  projectList: [],
  tagList: [],
  history: resetHistory(),
  myPatterns: [],
  teamPatterns: {},
  current_pattern: 'local',
  officialCalculators: [],
  officialLibrary: [],
  officialTags: []
}, action) => {

  switch(action.type){
    
    case 'DOWNLOAD_TEXT':
      downloadPatFile(state.cache[action.data.cacheID], action.data.user, action.data.team, action.data.includeErrors, action.data.includeData, action.data.includeHidden, action.data.txtFormat);
      return {...state};

    case 'LEAVE_PATTERN':
      
      return {
        ...state,
        leftAt: action.data
      };

    case 'REVERT_TO_PRISTINE':

      var current_cache = state.cache;
      current_cache[action.data] = state.pristineCache[action.data];

      return {
        ...state,
        cache: current_cache
      }

    case 'UPDATE_FROM_TEXT':
      var current_cache = state.cache[action.data.cacheID];

      var new_cache = Object.assign({}, current_cache, action.data.pattern);

      if(new_cache.name === generateName(current_cache)) new_cache.name = current_cache.name;

      var max_row_length = 0;
      for(var i in new_cache.rows){
        if(new_cache.rows[i].cells.length > max_row_length) max_row_length = new_cache.rows[i].cells.length;
      }
      for(var i in new_cache.rows){
        while(new_cache.rows[i].cells.length < max_row_length){
          new_cache.rows[i].cells.push('')
        }
      }

      new_cache.mode = 'raster';
      new_cache.lastUpdatedFrom = 'text';
      new_cache = checkForErrors(new_cache);
      new_cache.hashedRows = quickHash(new_cache.rows);
      new_cache.hashedRowsAndStyle = quickHash(new_cache.rows, true);
      state.history = addToNewHistory(state.history, current_cache);
      
      state.cache[action.data.cacheID] = new_cache;
      state.cache[action.data.cacheID].unsavedChanges = true;
      return {...state}

    case 'UPDATE_FROM_SCALE':
      var current_cache = state.cache[action.data.cacheID];

      if(current_cache.scale_factor === undefined) current_cache.scale_factor = 1;

      var new_cache = Object.assign({}, current_cache, action.data.pattern);
      
      if(new_cache.scale_factor === 0 || new_cache.scale_factor === '' || !new_cache.scale_factor) new_cache.scale_factor = current_cache.scale_factor;

      if(new_cache.scale_factor !== current_cache.scale_factor){
        for(i = 0 ; i < new_cache.rows.length; i++){
          for(j = 0; j < new_cache.rows[i].cells.length; j++){
            if(j === 0) continue;
            if(new_cache.rows[i].cells[j]){
              new_cache.rows[i].cells[j] *= new_cache.scale_factor / current_cache.scale_factor;
            }
          }
        }
      }

      new_cache.text = generateText(new_cache);
      new_cache = checkForErrors(new_cache);
      new_cache.lastUpdatedFrom = 'calculator';
      new_cache.hashedRows = quickHash(new_cache.rows);
      new_cache.hashedRowsAndStyle = quickHash(new_cache.rows, true);
      // new_cache = JSON.parse(JSON.stringify(new_cache));
      new_cache = Object.assign({}, new_cache);

      state.history = addToNewHistory(state.history, current_cache);
      
      state.cache[action.data.cacheID] = new_cache;
      state.cache[action.data.cacheID].unsavedChanges = true;
      return {...state}


    case 'UPDATE_FROM_ROTATE':
      var current_cache = state.cache[action.data.cacheID];

      if(current_cache.rotate_angle === undefined || current_cache.rotate_angle === '' || isNaN(current_cache.rotate_angle)) current_cache.rotate_angle = 0;

      var new_cache = Object.assign({}, current_cache, action.data.pattern);
      
      if(new_cache.rotate_angle === '' || isNaN(new_cache.rotate_angle)) new_cache.rotate_angle = current_cache.rotate_angle;

      // console.log(new_cache.rotate_angle, current_cache.rotate_angle);

      if(new_cache.rotate_angle !== current_cache.rotate_angle){
        var radians = (new_cache.rotate_angle - current_cache.rotate_angle) * (Math.PI/180);
        // console.log(radians);

        for(i = 0 ; i < new_cache.rows.length; i++){
          new_cache.rows[i].cells[0] = new_cache.rows[i].cells[0] + (new_cache.rotate_angle - current_cache.rotate_angle);
         

          var x = new_cache.rows[i].cells[1];
          var y = new_cache.rows[i].cells[2];
          // console.log('xyb',x,y);

          new_cache.rows[i].cells[1] = Math.cos(radians) * (x) - Math.sin(radians) * (y);//, new_cache.decimal_places;
          new_cache.rows[i].cells[2] = Math.sin(radians) * (x) + Math.cos(radians) * (y);//, new_cache.decimal_places;
          // console.log('xya',new_cache.rows[i].cells[1], new_cache.rows[i].cells[2])
        }
      }

      new_cache.text = generateText(new_cache);
      new_cache = checkForErrors(new_cache);
      new_cache.lastUpdatedFrom = 'calculator';
      new_cache.hashedRows = quickHash(new_cache.rows);
      new_cache.hashedRowsAndStyle = quickHash(new_cache.rows, true);
      new_cache = Object.assign({}, new_cache);

      state.history = addToNewHistory(state.history, current_cache);
      
      state.cache[action.data.cacheID] = new_cache;
      state.cache[action.data.cacheID].unsavedChanges = true;
      return {...state}

    case 'UPDATE_FROM_DATA':
      var current_cache = state.cache[action.data.cacheID];
      var new_cache = Object.assign({}, current_cache, action.data.pattern);

      if(new_cache.type.toUpperCase() !== 'MODEL' && new_cache.type.toUpperCase() !== 'DRAFTING'){
        new_cache.type = 'MODEL';
      }

      if(action.data.regenText){
        new_cache.text = generateText(new_cache);
      }
      
      new_cache = checkForErrors(new_cache);
      new_cache.hashedRows = quickHash(new_cache.rows) + (action.data.forceRedraw ? new Date().getTime() : "");
      new_cache.hashedRowsAndStyle = quickHash(new_cache.rows, true) + (action.data.forceRedraw ? new Date().getTime() : "");
      // console.log(new_cache.hashedRows, new_cache.hashedRowsAndStyle);
      new_cache.lastUpdatedFrom = 'data';

      state.history = addToNewHistory(state.history, current_cache);

      state.tagList = addToList(state.tagList, new_cache.tags);
      state.projectList = addToList(state.projectList, new_cache.projects);

      state.cache[action.data.cacheID] = new_cache;
      state.cache[action.data.cacheID].unsavedChanges = true;
      return {...state}

    case 'UNDO':

      var undoIndex = state.history.undoIndex + 1;
      var recovered_pattern = state.history.memory[state.history.memory.length - undoIndex];
      if(recovered_pattern === undefined) return {...state}

      // we need to use this as an event to add the current state to memory, so we can come back with redo if needed
      if(undoIndex === 1){
        state.history = addToNewHistory(state.history, state.cache[action.data.cacheID]);
        undoIndex = 2;
      }
      state.history.undoIndex = undoIndex;
      state.cache[action.data.cacheID] = recovered_pattern;
      state.cache[action.data.cacheID].unsavedChanges = true;

      return {...state}

    case 'REDO':
 
      var undoIndex = state.history.undoIndex - 1;
      var recovered_pattern = state.history.memory[state.history.memory.length - undoIndex];
      if(recovered_pattern === undefined) return {...state}

      state.history.undoIndex = undoIndex;
      state.cache[action.data.cacheID] = recovered_pattern;
      state.cache[action.data.cacheID].unsavedChanges = true;

      return {...state}

    case 'CREATE_BLANK_PATTERN':
      var cache = state.cache;
      cache['local'] = {...blankPatternTemplate};
      cache['local'].mode = 'raster';

      if(action.data.format) cache['local'].format = action.data.format;
      if(action.data.type) cache['local'].type = action.data.type;
      if(action.data.units) cache['local'].units = action.data.units;
      if(action.data.private) cache['local'].private = action.data.private;

      return {
        ...state,
        cache: cache,
        current_pattern: 'local'
      }


    case 'CREATE_DRAWING_PATTERN':
      var cache = state.cache;
      // console.log(defaultJDISettings, blankDrawingPatternTemplate);
      cache['local'] = {...JSON.parse(JSON.stringify(blankDrawingPatternTemplate))};

      if(action.data.format) cache['local'].format = action.data.format;
      if(action.data.type) cache['local'].type = action.data.type;
      if(action.data.units) cache['local'].units = action.data.units;
      if(action.data.private) cache['local'].private = action.data.private;
      
      return {
        ...state,
        cache: cache,
        current_pattern: 'local'
      }

    case 'SET_CURRENT_PATTERN':

      return {
        ...state,
        history: resetHistory(),
        current_pattern: action.data.cacheID
      }

    case 'REQUEST_NEW_PATTERN':
      return {
        ...state,
        tryingToCreateNewPattern: true
      }

    case 'RECEIVE_NEW_PATTERN_FAIL':
      return {
        ...state,
        tryingToCreateNewPattern: false,
        patternAPIError: action.data
      }

    case 'RECEIVE_NEW_PATTERN_SUCCESS':

      var cache = state.cache;
      cache[action.data.id] = action.data;
      // cache[action.data.id].history = [];
      cache[action.data.id].undoIndex = 0;
      return {
        ...state,
        tryingToCreateNewPattern: false,
        patternAPIError: {errors: {}},
        history: resetHistory(),
        cache: cache
      }

    case 'REQUEST_LOAD_PATTERN':
      return {
        ...state,
        tryingToLoadPattern: true,
        tryingToCreateNewPattern: false,
      }

    case 'RECEIVE_LOAD_PATTERN_FAIL':
      return {
        ...state,
        tryingToLoadPattern: false,
        tryingToCreateNewPattern: false,
        patternAPIError: action.data
      }

    case 'RECEIVE_LOAD_PATTERN_SUCCESS':

      action.data.hashedRows = quickHash(action.data.rows);
      action.data.lastCalculatedHashedRows = quickHash(action.data.rows);

      if(action.data.mode === 'drawing'){
        if(!action.data.jdiSettings){
          action.data.jdiSettings = {
            canvas_width: action.data.width,
            canvas_height: action.data.height,
          }
        }
        action.data.jdiSettings = deepDefaults(action.data.jdiSettings, defaultJDISettings);

        let mindim = action.data.jdiSettings.canvas_width < action.data.jdiSettings.canvas_height ? action.data.jdiSettings.canvas_width : action.data.jdiSettings.canvas_width;

        if(action.data.grid_snap_size > mindim / 2){
          action.data.grid_snap_size = mindim / 2;
        }
      }


      var cache = state.cache;

      // names only come through for team pattern loads, so if that already happened lets keep it.
      if(cache[action.data.id] && cache[action.data.id].created_by_name){
        action.data.created_by_name = cache[action.data.id].created_by_name;
      }
      // action.data.history = [];
      cache[action.data.id] = Object.assign({}, blankPatternTemplate, action.data);

      var pristineCache = state.pristineCache;
      pristineCache[action.data.id] = JSON.parse(JSON.stringify(cache[action.data.id]));

      return {
        ...state,
        tryingToLoadPattern: false,
        tryingToCreateNewPattern: false,
        history: resetHistory(),
        patternAPIError: {errors: {}},
        cache: cache,
        pristineCache: pristineCache
      }


    case 'FORGET_CHANGES':

      var cache = state.cache;
      cache[action.data.id] = JSON.parse(JSON.stringify(state.pristineCache[action.data.id]));

      return {
        ...state,
        history: resetHistory(),
        cache: cache
      }

    case 'REQUEST_DELETE_PATTERN':
      return {
        ...state,
        tryingToDeletePattern: true
      }

    case 'RECEIVE_DELETE_PATTERN_FAIL':
      return {
        ...state,
        tryingToDeletePattern: false,
        patternAPIError: action.data
      }

    case 'RECEIVE_DELETE_PATTERN_SUCCESS':
      var cache = state.cache;
      delete cache[action.data.id].scope;
      return {
        ...state,
        cache: cache,
        tryingToDeletePattern: false,
        patternAPIError: {errors: {}}
      }


    case 'REQUEST_RENDER_PATTERN':
      return {
        ...state,
        tryingToRenderPattern: true,
      }

    case 'RECEIVE_RENDER_PATTERN_FAIL':
      return {
        ...state,
        tryingToRenderPattern: false,
        failedToRenderPattern: new Date().getTime(),
      }

    case 'RECEIVE_RENDER_PATTERN_SUCCESS':

      var cache = state.cache;
      cache[state.current_pattern].temp_render = action.data.data;
      return {
        ...state,
        tryingToRenderPattern: false,
        successfullyRenderedPattern: new Date().getTime(),
        cache: cache
      }



    case 'REQUEST_LOG_DOWNLOAD_PATTERN':
      return {
        ...state,
        tryingToLogPatternDownload: true,
      }

    case 'RECEIVE_LOG_DOWNLOAD_PATTERN_FAIL':
      return {
        ...state,
        tryingToLogPatternDownload: false,
      }

    case 'RECEIVE_LOG_DOWNLOAD_PATTERN_SUCCESS':

      var cache = state.cache;
      cache[action.data.id].stats = action.data.stats;

      var pristineCache = state.pristineCache;
      pristineCache[action.data.id].stats = action.data.stats;

      return {
        ...state,
        tryingToLogPatternDownload: false,
        cache: cache,
        pristineCache: pristineCache
      }

    case 'REQUEST_UPDATE_PATTERN':
      return {
        ...state,
        tryingToUpdatePattern: true,
        tryingToCreateNewPattern: false,
      }

    case 'RECEIVE_UPDATE_PATTERN_FAIL':
      return {
        ...state,
        tryingToUpdatePattern: false,
        tryingToCreateNewPattern: false,
        patternAPIError: action.data
      }

    case 'RECEIVE_UPDATE_PATTERN_SUCCESS':

      var cache = state.cache;
      // commented these out because it was conflicting with the server
      // var historyToSave = cache[action.data.id].history;
      // var undoIndex = cache[action.data.id].undoIndex;
      // cache[action.data.id] = action.data;
      // cache[action.data.id].history = historyToSave;
      cache[action.data.id].updated_on = action.data.updated_on;
      cache[action.data.id].thumbnailDataUrl = action.data.thumbnailDataUrl;
      cache[action.data.id].unsavedChanges = false;

      var pristineCache = state.pristineCache;
      pristineCache[action.data.id] = JSON.parse(JSON.stringify(cache[action.data.id]));

      return {
        ...state,
        tryingToUpdatePattern: false,
        tryingToCreateNewPattern: false,
        patternAPIError: {errors: {}},
        cache: cache,
        pristineCache: pristineCache
      }

    case 'REQUEST_CALCULATE_PATTERN':

      var current_cache = state.cache[action.data.cacheID];
      var new_cache = Object.assign({}, current_cache);
      new_cache.variables = action.data.variables;
      state.cache[action.data.cacheID] = new_cache;

      return {
        ...state,
        tryingToCalculatePattern: true
      }

    case 'RECEIVE_CALCULATE_PATTERN_FAIL':
      return {
        ...state,
        tryingToCalculatePattern: false,
        calculatorError: true,
        patternAPIError: action.data
      }

    case 'RECEIVE_CALCULATE_PATTERN_SUCCESS':

      
      var current_cache = state.cache[action.data.cacheID];
      var new_cache = Object.assign({}, current_cache);

      new_cache.rows = action.data.rows;


      new_cache.variables = action.data.variables;
      new_cache.text = generateText(new_cache);
      new_cache = checkForErrors(new_cache);
      new_cache.lastUpdatedFrom = 'calculator';

      new_cache.hashedRows = quickHash(new_cache.rows);
      new_cache.hashedRowsAndStyle = quickHash(new_cache.rows, true);
      new_cache.lastCalculatedHashedRows = quickHash(new_cache.rows);

      state.history = addToNewHistory(state.history, current_cache);

      state.cache[action.data.cacheID] = new_cache;
      state.cache[action.data.cacheID].unsavedChanges = true;

      return {...state,
        tryingToCalculatePattern: false,
        calculatorError: false,
        patternAPIError: {errors: {}}
      }
      

    case 'REQUEST_MY_PATTERNS':
      return {
        ...state,
        tryingToGetMyPatterns: true
      }

    case 'RECEIVE_MY_PATTERNS_FAIL':
      return {
        ...state,
        tryingToGetMyPatterns: false,
        patternAPIError: action.data
      }

    case 'RECEIVE_MY_PATTERNS_SUCCESS':

      var new_cache = Object.assign({}, state.cache);
      var new_pristineCache = Object.assign({}, state.pristineCache);

      var myPatterns = [];
      var tagList = [];
      // var projectList = [];


      for(var i in action.data){

        if(action.data[i].mode === 'drawing'){
          if(!action.data[i].jdiSettings){
            action.data[i].jdiSettings = {
              canvas_width: action.data[i].width,
              canvas_height: action.data[i].height,
            }
          }
          action.data[i].jdiSettings = deepDefaults(action.data[i].jdiSettings, defaultJDISettings);

          let mindim = action.data[i].jdiSettings.canvas_width < action.data[i].jdiSettings.canvas_height ? action.data[i].jdiSettings.canvas_width : action.data[i].jdiSettings.canvas_width;

          if(action.data[i].grid_snap_size > mindim / 2){
            action.data[i].grid_snap_size = mindim / 2;
          }
        }

        new_cache[action.data[i].id] = action.data[i];
        new_cache[action.data[i].id].history = [];
        new_cache[action.data[i].id].undoIndex = 0;
        
        new_cache[action.data[i].id].jdiSettings = deepDefaults(new_cache[action.data[i].id].jdiSettings, defaultJDISettings);
        
        tagList = addToList(tagList, action.data[i].tags);

        myPatterns.push(action.data[i].id);


        new_pristineCache[action.data[i].id] = JSON.parse(JSON.stringify(new_cache[action.data[i].id]));
      }

      myPatterns.sort(function(a, b){
        if(new_cache[a].updated_on > new_cache[b].updated_on) return -1;
        return 1;
      })

      return {
        ...state,
        tryingToGetMyPatterns: false,
        successfullyGotMyPatterns: new Date().getTime(),
        patternAPIError: {errors: {}},
        cache: new_cache,
        pristineCache: new_pristineCache,
        tagList: tagList,
        // projectList: projectList,
        myPatterns: myPatterns
      }


    case 'REQUEST_TEAM_PATTERNS':
      return {
        ...state,
        tryingToGetTeamPatterns: true
      }

    case 'RECEIVE_TEAM_PATTERNS_FAIL':
      return {
        ...state,
        tryingToGetTeamPatterns: false,
        patternAPIError: action.data
      }

    case 'RECEIVE_TEAM_PATTERNS_SUCCESS':

      var new_cache = Object.assign({}, state.cache);

      var new_pristineCache = Object.assign({}, state.pristineCache);

      var patterns = [];
      var tagList = [];
      var projectList = [];

      for(var i in action.data){

        if(action.data[i].mode === 'drawing'){
          if(!action.data[i].jdiSettings){
            action.data[i].jdiSettings = {
              canvas_width: action.data[i].width,
              canvas_height: action.data[i].height,
            }
          }
          action.data[i].jdiSettings = deepDefaults(action.data[i].jdiSettings, defaultJDISettings);

          let mindim = action.data[i].jdiSettings.canvas_width < action.data[i].jdiSettings.canvas_height ? action.data[i].jdiSettings.canvas_width : action.data[i].jdiSettings.canvas_width;

          if(action.data[i].grid_snap_size > mindim / 2){
            action.data[i].grid_snap_size = mindim / 2;
          }
        }
        
        new_cache[action.data[i].id] = action.data[i];
        new_cache[action.data[i].id].history = [];
        new_cache[action.data[i].id].undoIndex = 0;

        new_cache[action.data[i].id].jdiSettings = deepDefaults(new_cache[action.data[i].id].jdiSettings, defaultJDISettings);
        
        tagList = addToList(tagList, action.data[i].tags);
        projectList = addToList(projectList, action.data[i].projects);

        patterns.push(action.data[i].id);

        new_pristineCache[action.data[i].id] = JSON.parse(JSON.stringify(new_cache[action.data[i].id]));
      }

      patterns.sort(function(a, b){
        if(new_cache[a].updated_on > new_cache[b].updated_on) return -1;
        return 1;
      })

      var teamPatterns = state.teamPatterns;
      if(action.data.length > 0){
        teamPatterns[action.data[0].scope] = patterns;
      }

      return {
        ...state,
        tryingToGetTeamPatterns: false,
        successfullyGotTeamPatterns: new Date().getTime(),
        patternAPIError: {errors: {}},
        tagList: tagList,
        projectList: projectList,
        cache: new_cache,
        pristineCache: new_pristineCache,
        teamPatterns: teamPatterns
      }

    case 'REQUEST_OFFICIAL_PATTERNS':
      return {
        ...state,
        tryingToGetOfficialPatterns: true
      }

    case 'RECEIVE_OFFICIAL_PATTERNS_FAIL':
      return {
        ...state,
        tryingToGetOfficialPatterns: false,
        patternAPIError: action.data
      }

    case 'RECEIVE_OFFICIAL_PATTERNS_SUCCESS':

      let new_cache = Object.assign({}, state.cache);
      var new_pristineCache = Object.assign({}, state.pristineCache);

      let officialCalculators = [];
      let officialLibrary = [];

      let tagList = [];

      for(let i in action.data){
        if(!new_cache[action.data[i].id]){
          new_cache[action.data[i].id] = action.data[i];
          new_cache[action.data[i].id].history = [];
          new_cache[action.data[i].id].undoIndex = 0;
        }

        if(action.data[i].projects){
          if(action.data[i].projects.indexOf('Pattycake Templates') > -1){
            officialCalculators.push(action.data[i].id);
          }
          if(action.data[i].projects.indexOf('Pattycake Library') > -1){
            officialLibrary.push(action.data[i].id);

            for(var ii in action.data[i].tags){
              if(!tagList.find(t => t == action.data[i].tags[ii].toLowerCase())){
                tagList.push(action.data[i].tags[ii].toLowerCase());
              }
            }
          }
        }

        new_pristineCache[action.data[i].id] = JSON.parse(JSON.stringify(new_cache[action.data[i].id]));
      }

      

      return {
        ...state,
        tryingToGetOfficialPatterns: false,
        patternAPIError: {errors: {}},
        cache: new_cache,
        pristineCache: new_pristineCache,
        officialCalculators: officialCalculators,
        officialLibrary: officialLibrary,
        officialTags: tagList
      }

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducers.patternManager.js